// R24 Consent Controller (cookiecorner + r24_consent LS)
//
export function initMetaCookies() {
    const STORAGE_KEY = 'r24_consent';
    const CSP_COOKIE = 'r24_csp';
    const banner = document.getElementById('r24ConsentBanner');
    if (!banner) {
        window.cookiePop = function () {
            const el = document.querySelector('.cookiecorner');
            if (!el) return;
            el.classList.add('cookiehello');
            el.classList.remove('is-settings-open');
            el.setAttribute('aria-hidden', 'false');
        };
        $('#footersettings, .cookie-settings-button').on('click', function (e) {
            e.preventDefault();
            window.cookiePop();
        });
        return;
    }

    const revision = banner.dataset.consentRevision || '';
    const logUrl = banner.dataset.consentLog || '/consent/log';
    const locale = banner.dataset.consentLocale || 'de';
    let registry = [];
    try {
        registry = JSON.parse(banner.dataset.consentServices || '[]');
    } catch (e) {
        registry = [];
    }

    const categoriesOffered = [...new Set(registry.map((s) => s.category))];

    function uuid() {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
        return 'c_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    }

    function needsConsent(serviceOrId) {
        if (typeof serviceOrId === 'string') {
            const s = registry.find((x) => x.id === serviceOrId);
            return !s || s.requiresConsent !== false;
        }
        return serviceOrId.requiresConsent !== false;
    }

    function emptyState() {
        const categories = { analytics: false, marketing: false, functional: false, media: false };
        const services = {};
        registry.forEach((s) => {
            services[s.id] = needsConsent(s) === false; // Pirsch etc. default on
        });
        const state = {
            id: uuid(),
            revision,
            updatedAt: new Date().toISOString(),
            categories,
            services,
            status: 'pending',
        };
        syncCategoriesFromServices(state);
        return state;
    }

    function migrateLegacy() {
        const cookie = localStorage.getItem('cookie');
        if (cookie === null && localStorage.getItem(STORAGE_KEY)) return null;
        const hasLegacy = localStorage.getItem('cookieRuleAnalytics') !== null
            || localStorage.getItem('cookieRuleMarketing') !== null
            || localStorage.getItem('cookieRuleVimeo') !== null
            || cookie !== null;
        if (!hasLegacy) return null;

        const state = emptyState();
        const analyticsOn = localStorage.getItem('cookieRuleAnalytics') === 'on';
        const marketingOn = localStorage.getItem('cookieRuleMarketing') === 'on';
        const vimeoOn = localStorage.getItem('cookieRuleVimeo') === 'on';
        const pipedriveOn = localStorage.getItem('cookieRulePipedrive') === 'on';

        registry.forEach((s) => {
            let on = false;
            if (needsConsent(s) === false) on = true;
            else if (s.id === 'pirsch') on = analyticsOn;
            else if (s.id === 'vimeo') on = vimeoOn;
            else if (s.id === 'pipedrive') on = pipedriveOn || (cookie === 'superokay');
            else if (s.category === 'analytics') on = analyticsOn || marketingOn;
            else if (s.category === 'marketing') on = marketingOn;
            else if (s.category === 'functional' || s.category === 'media') on = vimeoOn;
            state.services[s.id] = on;
        });
        syncCategoriesFromServices(state);
        if (cookie === 'superokay' || cookie === 'okay') {
            state.status = cookie === 'superokay' ? 'accept' : 'save';
        }
        return state;
    }

    function categoryServiceIds(cat) {
        return registry.filter((s) => s.category === cat).map((s) => s.id);
    }

    function syncCategoriesFromServices(state) {
        categoriesOffered.forEach((cat) => {
            const ids = categoryServiceIds(cat).filter((id) => needsConsent(id));
            // Only consent-required services count for category toggle state
            state.categories[cat] = ids.length > 0 && ids.every((id) => state.services[id] === true);
            if (ids.length === 0) {
                // Category only has always-on services
                state.categories[cat] = categoryServiceIds(cat).length > 0;
            }
        });
    }

    function forceExemptOn(state) {
        registry.forEach((s) => {
            if (needsConsent(s) === false) {
                state.services[s.id] = true;
            }
        });
    }

    function writeCspCookie(next) {
        const secure = location.protocol === 'https:' ? '; Secure' : '';
        const base = `; Path=/; SameSite=Lax${secure}`;
        // Only accept/save may grant CSP; reject clears optional vendors
        if (next.status !== 'accept' && next.status !== 'save') {
            document.cookie = `${CSP_COOKIE}=; Max-Age=0${base}`;
            return;
        }
        const ids = registry
            .filter((s) => needsConsent(s) && next.services[s.id] === true)
            .map((s) => s.id)
            .filter(Boolean);
        if (ids.length === 0) {
            document.cookie = `${CSP_COOKIE}=; Max-Age=0${base}`;
            return;
        }
        document.cookie = `${CSP_COOKIE}=${encodeURIComponent(ids.join(','))}; Max-Age=31536000${base}`;
    }

    function loadState() {
        let loaded = null;
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw) loaded = JSON.parse(raw);
        } catch (e) {
            loaded = null;
        }

        let seeded = false;
        let revisionStale = false;
        if (!loaded || typeof loaded !== 'object') {
            loaded = migrateLegacy() || emptyState();
            seeded = true;
        }

        registry.forEach((s) => {
            if (typeof loaded.services[s.id] !== 'boolean') {
                loaded.services[s.id] = needsConsent(s) === false;
            }
        });
        if (!loaded.categories) {
            loaded.categories = { analytics: false, marketing: false, functional: false, media: false };
        }
        forceExemptOn(loaded);
        syncCategoriesFromServices(loaded);

        if (loaded.revision && revision && loaded.revision !== revision) {
            loaded.status = 'pending';
            loaded.revision = revision;
            revisionStale = true;
            // Clear consent-required grants so GTM / helpers stay denied until re-consent
            registry.forEach((s) => {
                loaded.services[s.id] = needsConsent(s) === false;
            });
            syncCategoriesFromServices(loaded);
        } else if (!loaded.revision) {
            loaded.revision = revision;
        }

        if (seeded || revisionStale) {
            // Write LS directly — do not call persist() here (TDZ on outer `state`)
            loaded.updatedAt = new Date().toISOString();
            if (!loaded.id) loaded.id = uuid();
            localStorage.setItem(STORAGE_KEY, JSON.stringify(loaded));
            writeCspCookie(loaded);
        }

        return loaded;
    }

    let state = loadState();

    function persist(next) {
        next.updatedAt = new Date().toISOString();
        next.revision = revision;
        if (!next.id) next.id = uuid();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        writeCspCookie(next);
        state = next;
    }

    function paint() {
        categoriesOffered.forEach((cat) => {
            const ids = categoryServiceIds(cat).filter((id) => needsConsent(id));
            const onCount = ids.filter((id) => state.services[id]).length;
            const input = banner.querySelector(`input[data-consent-cat="${cat}"]`);
            if (!input) return;
            if (ids.length === 0) {
                input.indeterminate = false;
                input.checked = true;
                input.disabled = true;
                input.setAttribute('aria-checked', 'true');
                return;
            }
            input.disabled = false;
            input.indeterminate = onCount > 0 && onCount < ids.length;
            input.checked = onCount === ids.length;
            input.setAttribute('aria-checked', input.indeterminate ? 'mixed' : (input.checked ? 'true' : 'false'));
        });

        registry.forEach((s) => {
            const input = banner.querySelector(`input[data-consent-svc="${s.id}"]`);
            if (!input) return;
            const on = needsConsent(s) === false ? true : !!state.services[s.id];
            input.checked = on;
            input.setAttribute('aria-checked', on ? 'true' : 'false');
            if (needsConsent(s) === false) {
                input.disabled = true;
                input.checked = true;
            }
        });

        const vimeoOn = !!state.services.vimeo;
        $(".vimeoblocker").toggleClass('formblockerhidden', vimeoOn);
        updateVimeoIframes(vimeoOn);
    }

    function updateVimeoIframes(vimeoOn) {
        // Background layer (.vimeo-wrapper) vs player host (.playerVimeo / .vimeo-wrapper-player)
        $('.vimeo-wrapper iframe, .vimeo-wrapper-player iframe').each(function () {
            const $iframe = $(this);
            const originalSrc = $iframe.attr('data-src') || $iframe.data('src') || $iframe.attr('src');
            if (originalSrc) {
                $iframe.attr('data-src', originalSrc);
                $iframe.data('src', originalSrc);
            }
            const $bg = $iframe.closest('.vimeo-wrapper');
            const $player = $iframe.closest('.playerVimeo');
            if (vimeoOn) {
                if (originalSrc) $iframe.attr('src', originalSrc);
                if ($bg.length) $bg.show();
                if ($player.length) $player.show();
            } else {
                $iframe.removeAttr('src');
                if ($bg.length) $bg.hide();
                if ($player.length) $player.hide();
            }
        });

        // Plyr embeds (no iframe until init) — hide host when consent off
        $('.vimeo-wrapper-player .playerVimeo').each(function () {
            if (vimeoOn) $(this).show();
            else $(this).hide();
        });
    }

    function setCategory(cat, on) {
        state.categories[cat] = !!on;
        categoryServiceIds(cat).forEach((id) => {
            if (needsConsent(id) === false) {
                state.services[id] = true;
                return;
            }
            state.services[id] = !!on;
        });
        paint();
    }

    function setService(id, on) {
        if (needsConsent(id) === false) {
            state.services[id] = true;
            paint();
            return;
        }
        state.services[id] = !!on;
        syncCategoriesFromServices(state);
        paint();
    }

    function acceptAll() {
        registry.forEach((s) => { state.services[s.id] = true; });
        syncCategoriesFromServices(state);
        state.status = 'accept';
        paint();
    }

    function rejectAll() {
        registry.forEach((s) => {
            state.services[s.id] = needsConsent(s) === false;
        });
        syncCategoriesFromServices(state);
        state.status = 'reject';
        paint();
    }

    function isCommittedStatus(status) {
        return status === 'accept' || status === 'save' || status === 'reject';
    }

    async function logConsent(action) {
        try {
            await fetch(logUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    action,
                    revision: state.revision,
                    locale,
                    categories: state.categories,
                    services: state.services,
                    consentId: state.id,
                    id: state.id,
                }),
            });
        } catch (e) {
            // non-blocking
        }
    }

    async function commit(action) {
        if (action === 'accept') {
            state.status = 'accept';
        } else if (action === 'reject') {
            state.status = 'reject';
        } else {
            state.status = 'save';
        }
        persist(state);
        await logConsent(action === 'accept' || action === 'reject' ? action : 'save');
        location.reload();
    }

    function setCategoryOpen(section, open) {
        const btn = section.querySelector('.cookiecorner-cat-expand');
        const panel = section.querySelector('.cookiecorner-cat-panel');
        if (!btn || !panel) return;
        section.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
            panel.removeAttribute('hidden');
        } else {
            panel.setAttribute('hidden', '');
        }
    }

    const actionsWrap = banner.querySelector('.cookiecorner-actions-wrap');
    const actionsEl = banner.querySelector('.cookiecorner-actions');
    const detailsEl = banner.querySelector('#r24ConsentDetails');
    const settingsBtn = banner.querySelector('#cookieSettings');
    const bottomEl = banner.querySelector('.cookiecorner-bottom');
    let settingsOpen = false;

    function setSettingsOpen(open) {
        settingsOpen = !!open;
        banner.classList.toggle('is-settings-open', settingsOpen);

        if (settingsBtn) {
            settingsBtn.setAttribute('aria-expanded', settingsOpen ? 'true' : 'false');
        }

        if (detailsEl) {
            detailsEl.setAttribute('aria-hidden', settingsOpen ? 'false' : 'true');
            if (settingsOpen) {
                detailsEl.removeAttribute('inert');
            } else {
                detailsEl.setAttribute('inert', '');
            }
        }

        if (actionsWrap) {
            actionsWrap.setAttribute('aria-hidden', settingsOpen ? 'true' : 'false');
            if (settingsOpen) {
                actionsWrap.setAttribute('inert', '');
            } else {
                actionsWrap.removeAttribute('inert');
            }
        }

        // After CSS expand, move focus into the detail actions
        if (settingsOpen && bottomEl) {
            window.setTimeout(() => {
                const focusTarget = bottomEl.querySelector('#cookieBigSettings, button');
                focusTarget?.focus({ preventScroll: true });
            }, 420);
        }

        paint();
    }

    function showBanner(intro = true) {
        banner.classList.add('cookiehello');
        banner.setAttribute('aria-hidden', 'false');
        if (intro) {
            setSettingsOpen(false);
            // Do not auto-focus a choice button — visible focus ring looks like a pre-selected CTA
        }
    }

    function toggleModal(close = false) {
        if (close) {
            banner.classList.remove('cookiehello');
            banner.setAttribute('aria-hidden', 'true');
            setSettingsOpen(false);
            return;
        }
        // Always open in intro mode (2 top buttons)
        showBanner(true);
    }

    function cookiePop() {
        toggleModal(false);
    }
    window.cookiePop = cookiePop;

    setSettingsOpen(false);

    const needsPrompt = !isCommittedStatus(state.status);
    if (needsPrompt) {
        window.setTimeout(() => showBanner(true), 500);
    }

    $(banner).on('change', 'input[data-consent-cat]', function () {
        setCategory(this.getAttribute('data-consent-cat'), this.checked);
    });

    $(banner).on('change', 'input[data-consent-svc]', function () {
        setService(this.getAttribute('data-consent-svc'), this.checked);
    });

    $(banner).on('click', '.cookiecorner-cat-expand', function (e) {
        e.preventDefault();
        const section = this.closest('.cookiecorner-cat');
        if (!section) return;
        setCategoryOpen(section, !section.classList.contains('is-open'));
    });

    $('#cookieSuperokay, #cookieBigSuperokay').on('click', function (e) {
        e.preventDefault();
        acceptAll();
        commit('accept');
    });

    $('#cookieReject').on('click', function (e) {
        e.preventDefault();
        rejectAll();
        commit('reject');
    });

    $('#cookieBigSettings').on('click', function (e) {
        e.preventDefault();
        commit('save');
    });

    // Expand details via CSS class — intro buttons collapse, bottom actions appear
    $('#cookieSettings').on('click', function (e) {
        e.preventDefault();
        setSettingsOpen(true);
    });

    // Escape: collapse settings back to intro (keep dialog open until choice)
    banner.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (settingsOpen) {
            e.preventDefault();
            setSettingsOpen(false);
            settingsBtn?.focus({ preventScroll: true });
        }
    });

    $('#footersettings').on('click', function (e) {
        e.preventDefault();
        cookiePop();
    });

    $('.vimeoblockerBtn').on('click', function (e) {
        e.preventDefault();
        setService('vimeo', true);
        commit('save');
    });

    if (document.querySelectorAll('.cookie-settings-button').length > 0) {
        document.addEventListener('click', function (event) {
            if (event.target.matches('.cookie-settings-button')) {
                cookiePop();
            }
        });
    }

    paint();
}
